/**
 * 获取定位信息
 * https://km.sankuai.com/collabpage/1559647983
 */
const getUserLocation = () => {
  const SLLocation = Mach.requireModule('SLLocation')
  const loc = SLLocation.getLocation() || {}
  return loc
}

export { getUserLocation }
